import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LinkButton from "../../components/LinkButton";
import { IoMdShare } from "react-icons/io";
import Modal from "pages/Profile/components/Modal";

import {
  MdRateReview,
  MdLock,
  MdDelete,
  MdCancelScheduleSend,
} from "react-icons/md";
import { RiEdit2Fill } from "react-icons/ri";
import RenameList from "./RenameList";
import {
  deleteList,
  lockList,
  setActiveList,
  setList,
  setListItems,
  setLists,
} from "../../../../store/actions/Store/list";
import { showToast } from "../../../../utils/showToast";
import {
  handleListRequest,
  unShareList,
} from "../../../../store/services/Store/List";
import { IoMdUnlock } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import ShareList from "./ShareList";
import { getUserDashboard } from "store/services/Authentication";
import { getDashboard } from "store/actions/Authentication";
const SettingCard = ({ li, props, handleSettingsToggle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { user } = useSelector((store) => store.userReducer);
  const [membersOpen, setMembersOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };
  const handleMembersToggle = () => {
    setMembersOpen(!membersOpen);
  };
  const openModalForRename = () => {
    props.handleClose(true);
  };
  const handleDeleteList = async () => {
    if (li.active) {
      showToast(
        "Unable to delete list. Cannot delete an Active List. Make another list active to delete this list.",
        "error",
        false,
        "Close"
      );
      return;
    }
    if (li.owner && li.list_count > 1 && !selectedStore?.isWhiteLabel) {
      setIsModalOpen(true);
      return;
    }
    const result = await handleListRequest({
      method: "delete",
      url: `users/${user.data.id}/lists/${li.list_id}`,
      token: user.accessToken,
    });
    if (result.success) {
      dispatch(deleteList(li.list_id));
      showToast("List deleted successfully", "success", true);
      handleSettingsToggle(li.list_id);
    } else {
      showToast(result.message, "error", false);
    }
  };

  const handleLockList = async (lockValue) => {
    if (!li.active) {
      showToast("Please make the list acitve first.", "error", true);
      return;
    }
    const result = await handleListRequest({
      method: "put",
      url: `users/${user.data.id}/lists/${li.list_id}/lock`,
      token: user.accessToken,
      data: {
        lock: !lockValue,
      },
    });
    if (result.success) {
      const toogleListLock = { ...li, lock: !lockValue };
      dispatch(lockList({ list_id: li.list_id, newLockStatus: !lockValue }));
      dispatch(setActiveList(toogleListLock));
      showToast(result.data, "success", true);
      handleSettingsToggle(li.list_id);
    } else {
      showToast(result.message, "error", false);
    }
  };
  const handleReviewList = (li) => {
    dispatch(setList(li));
    navigate(`/stores/${selectedStore.id}/lists/${li.list_id}/review`);
  };
  const handleUnshareList = async (li) => {
    const unshare = await unShareList(
      user.accessToken,
      user.data.id,
      selectedStore.id,
      li.list_id
    );
    if (unshare.success) {
      const result = await getUserDashboard({
        store_id: selectedStore.id,
        user_id: user.data.id,
        token: user.accessToken,
      });
      if (result.data) {
        dispatch(setLists(result.data.lists));

        dispatch(setListItems(result.data.lists));
        dispatch(getDashboard(result.data));
        handleSettingsToggle(li.list_id);
        showToast(unshare.data, "success", true);
      } else if (!result.success) {
        showToast(result.message, "error", true);
      }
    } else {
      showToast(unshare.message, "error", true);
    }
  };
  let settingData = [
    {
      text: "Share List",
      icon: IoMdShare,
      onClick: () => handleMembersToggle(),
      id: "share-list",
    },
    {
      text: "Unshare List",
      icon: MdCancelScheduleSend,
      onClick: () => handleUnshareList(li),
      id: "unshare-list",
    },
    li.items_count && {
      text: "Review List",
      icon: MdRateReview,
      onClick: () => handleReviewList(li),
      id: "review-list",
    },
    li.active && {
      text: "Lock List",
      icon: MdLock,
      onClick: () => handleLockList(li.lock),
      id: "lock-list",
    },
    {
      text: "Rename List",
      icon: RiEdit2Fill,
      onClick: openModalForRename,
      id: "rename-list",
    },
    {
      text: "Delete List",
      icon: MdDelete,
      onClick: handleDeleteList,
      id: "delete-list",
    },
  ].filter(Boolean);

  if (li.active && li.lock) {
    settingData = [
      {
        text: "Unlock List",
        icon: IoMdUnlock,
        onClick: () => handleLockList(li.lock),
      },
      {
        text: "Share List",
        icon: IoMdShare,
        onClick: () => handleMembersToggle(),
        id: "share-list",
      },
      {
        text: "Unshare List",
        icon: MdCancelScheduleSend,
        onClick: () => handleUnshareList(li),
        id: "unshare-list",
      },
    ];
  }
  if (!li.active && li.lock) {
    settingData = [
      {
        text: "Share List",
        icon: IoMdShare,
        onClick: () => handleMembersToggle(),
        id: "share-list",
      },
      {
        text: "Unlock List",
        icon: IoMdUnlock,
        onClick: () => handleLockList(li.lock),
      },
    ];
  }
  if (li.isOrderPlaced || !li.owner) {
    settingData = [
      {
        text: "Review List",
        icon: MdRateReview,
        onClick: () => handleReviewList(li),
        id: "review-list",
      },
    ];
  }
  if (selectedStore?.isWhiteLabel) {
    settingData = [
      li.items_count && {
        text: "Review List",
        icon: MdRateReview,
        onClick: () => handleReviewList(li),
        id: "review-list",
      },
      {
        text: "Rename List",
        icon: RiEdit2Fill,
        onClick: openModalForRename,
        id: "rename-list",
      },
      {
        text: "Delete List",
        icon: MdDelete,
        onClick: handleDeleteList,
        id: "delete-list",
      },
    ];
  }
  if (selectedStore.isWhiteLabel && li.lock && !li.isOrderPlaced) {
    settingData = [
      {
        text: "Unlock List",
        icon: IoMdUnlock,
        onClick: () => handleLockList(li.lock),
      },
    ];
  }
  if (selectedStore?.isWhiteLabel && li.lock && li.isOrderPlaced) {
    settingData = [
      li.items_count && {
        text: "Review List",
        icon: MdRateReview,
        onClick: () => handleReviewList(li),
        id: "review-list",
      },
    ];
  }
  const generateLinkButtons = () => {
    return settingData.map((item) => {
      if (item.onClick) {
        return (
          <button
            key={item.id}
            className="flex gap-3 px-4 py-2 text-sm font-bold text-gray-900 w-full hover:bg-[#EBEFFF]"
            onClick={item.onClick}
          >
            <item.icon size={20} />
            <span>{item.text}</span>
          </button>
        );
      } else {
        return (
          <LinkButton
            key={item.id}
            className="flex gap-3 px-4 py-2 text-sm font-bold text-gray-900 w-full hover:bg-[#EBEFFF]"
            id={item.id}
            size={20}
            url={item.url}
            Icon={item.icon}
            text={item.text}
          />
        );
      }
    });
  };
  const generateWhiteLabelledStoreLinkButtons = () => {
    // eslint-disable-next-line array-callback-return
    return settingData.map((item) => {
      if (item.onClick) {
        return (
          <button
            key={item.id}
            className="flex gap-3 px-4 py-2 text-sm font-bold text-gray-900 w-full hover:bg-[#EBEFFF]"
            onClick={item.onClick}
          >
            <item.icon size={20} />
            <span>{item.text}</span>
          </button>
        );
      }
    });
  };
  const shareListModalData = {
    title: "Share List With",
  };
  const deleteSharedListModalContent = {
    title: "Note",
    description:
      "Delete Shared List? This action will remove the list from all accounts.",
    purpleButton: "CONTINUE",
    redButton: "CANCEL",
  };
  const sharedListDeleteHandler = async () => {
    const result = await handleListRequest({
      method: "delete",
      url: `users/${user.data.id}/lists/${li.list_id}`,
      token: user.accessToken,
    });
    if (result.success) {
      dispatch(deleteList(li.list_id));
      showToast("List deleted successfully", "success", true);
    }
  };
  return (
    <div className="relative">
      <div className="absolute z-20 font-bold text-center text-gray-800 bg-white border-2 rounded-lg shadow-lg top-1 w-44 md:w-40 md:text-sm right-2 md:right-1 lg:right-1">
        <div className="flex flex-col items-start justify-around my-2">
          {selectedStore?.isWhiteLabel
            ? generateWhiteLabelledStoreLinkButtons()
            : generateLinkButtons()}
        </div>
        {props.isOpen && (
          <RenameList
            handleSettingsToggle={handleSettingsToggle}
            li={li}
            props={props}
          />
        )}
      </div>
      <ShareList
        isOpen={membersOpen}
        handleClose={handleMembersToggle}
        shareListModalData={shareListModalData}
        handleSettingsToggle={handleSettingsToggle}
        li={li}
      />
      {isModalOpen && (
        <Modal
          modalData={deleteSharedListModalContent}
          handleModalToggle={handleModalToggle}
          isOpen={isModalOpen}
          submitHandler={sharedListDeleteHandler}
        />
      )}
    </div>
  );
};

export default SettingCard;
